/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";

export const SUBSCRIPTIONS_PATH = "/admin-store/subscriptions";
export const DASHBOARD_PATH = "/admin-store/dashboard";
export const SUBSCRIPTION_STATUS_EVENT = "madar-subscription-status";

export function isSubscriptionMarkedExpired() {
  return localStorage.getItem("subscriptionExpired") === "true";
}

export function markSubscriptionExpired(expired) {
  const next = Boolean(expired);
  const current = isSubscriptionMarkedExpired();
  localStorage.setItem("subscriptionExpired", next ? "true" : "false");
  if (current === next) return;
  window.dispatchEvent(
    new CustomEvent(SUBSCRIPTION_STATUS_EVENT, { detail: { expired: next } })
  );
}

export function isExpiredPlanAllowedPath(pathname = "") {
  const path = String(pathname).split("?")[0].replace(/\/+$/, "") || "/";
  return (
    path === "/admin-store" ||
    path === "/admin-store/dashboard" ||
    path.startsWith("/admin-store/subscriptions")
  );
}

let renewPrompt = null;

export function askToRenewExpiredPlan({ isArabic, isDark }) {
  if (renewPrompt) return renewPrompt;

  renewPrompt = Swal.fire({
    icon: "warning",
    title: isArabic ? "الخطة منتهية" : "Plan expired",
    text: isArabic
      ? "الخطة منتهية. هل تريد تجديد الاشتراك؟"
      : "Your plan has expired. Do you want to renew your subscription?",
    showCancelButton: true,
    confirmButtonText: isArabic ? "نعم، تجديد الاشتراك" : "Yes, renew",
    cancelButtonText: isArabic ? "لا" : "No",
    confirmButtonColor: "#7400BF",
    cancelButtonColor: "#6b7280",
    background: isDark ? "#1E293B" : "#fff",
    color: isDark ? "#fff" : "#000",
    reverseButtons: Boolean(isArabic),
  })
    .then((result) => Boolean(result.isConfirmed))
    .finally(() => {
      renewPrompt = null;
    });

  return renewPrompt;
}

export async function navigateWithExpiredPlanGuard(navigate, path, { isArabic, isDark }) {
  if (!path) return;
  if (!isSubscriptionMarkedExpired() || isExpiredPlanAllowedPath(path)) {
    navigate(path);
    return;
  }

  const renew = await askToRenewExpiredPlan({ isArabic, isDark });
  if (renew) navigate(SUBSCRIPTIONS_PATH);
}
